// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  staging: false,
  //development: true,
  development: false,
  ip: '/api/',
  endPoint: 'https://turksat.saatteknoloji.com.tr/api/',
  mwCoreEndpoint: 'https://turksat.saatteknoloji.com.tr/mw/',
  mwCrmEndpoint: 'https://turksat.saatteknoloji.com.tr/mw-crm/',
  oldEndPoint: '/api/',
  posterManagerApi: 'https://turksat.saatteknoloji.com.tr/api/',
  consumerApi: 'https://turksat.saatteknoloji.com.tr/',
  defaultPosterBaseUrl: 'https://turksat.saatteknoloji.com.tr/providers',
  agentEndpoint: 'https://turksat.saatteknoloji.com.tr/agent',
  mcpEndpoint: 'https://turksat.saatteknoloji.com.tr/mcp',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

